// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TestSendInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TestSendInput — body for POST /franchisor-channels/test-send.
 *
 * Fires a REAL adapter deliver() call against `target` (a raw email or
 * phone number typed by staff) — never against a stored recipient. Blank
 * credentials on the channel come back as the adapter's own pre-I/O
 * 'channel_not_configured' detail (no socket touched); that is a SUCCESSFUL
 * response with delivered:false, not a controller refusal.
 *
 * `template_id` (M2) switches the message from the canned test string to a
 * REAL template, rendered exactly as the preview panel renders it
 * (libraries/channels/TemplatePreview). Omitting it keeps the original
 * behaviour, so the existing button is unchanged. Refusals it adds:
 * 'template_not_found', 'template_channel_type_mismatch' (an sms template
 * through an email channel, same law trigger_save enforces),
 * 'template_error:<token>', 'franquia_not_found'.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_TestSendInput {
channel_id: number
target: string
template_id?: number
vars?: Record<string, string>
franquia_id?: number
}

registerContract('FranchisorChannels_TestSendInput', {
  channel_id:  { type: 'number',  required: true },
  target:      { type: 'string',  required: true },
  template_id: { type: 'number',  required: false },
  vars:        { type: 'object',  required: false },
  franquia_id: { type: 'number',  required: false },
})
